export const API_STATUS = Object.freeze({
    PENDING: 'Pending',
    REJECTED: 'Rejected',
    FULFILLED: 'Fulfilled',
    NETWORK_ERROR: 'Network Error'
})